import { Text } from '@cmpsr/components';

type ModalIntroWizardStepTitleProps = {
  activeStep: number;
};

export default function ModalIntroWizardStepTitle(props: ModalIntroWizardStepTitleProps) {
  return renderSwitch(props.activeStep);
}

function renderSwitch(activeStep: number): React.ReactNode {
  switch (activeStep) {
    case 1: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          Your recommended actions{' '}
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            directly tie
          </Text>{' '}
          to your top cancer risk factors
        </Text>
      );
    }
    case 2: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            You choose
          </Text>{' '}
          where you want to focus
        </Text>
      );
    }
    case 3: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          Your Action Plan changes with{' '}
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            you
          </Text>
        </Text>
      );
    }
    case 4: {
      return (
        <Text as="h1" variant="text-header-L" color="text-light">
          Track your progress,{' '}
          <Text as="span" textStyle="text-header-l-v" color="text-light !important">
            reduce your risk
          </Text>{' '}
        </Text>
      );
    }
  }
}
